import { Label } from 'semantic-ui-react';
import React from 'react';
import cn from 'classnames';
import { string, node } from 'prop-types';
import { Field } from 'formik';

const Textarea = ({ className, label, error, qa, ...rest }) => {
  const fieldCSS = cn('field', className, error && 'error');
  // querySelector does not work with dots(.) - for e2e
  const id = rest.name && rest.name.replace('.', '_');
  return (
    <div className={fieldCSS}>
      <label htmlFor={id}>{label}</label>
      <Field data-qa={qa} id={id} {...rest} component="textarea" />
      {error && (
        <Label basic pointing color="red">
          {error}
        </Label>
      )}
    </div>
  );
};

Textarea.propTypes = {
  className: string,
  error: node,
  label: node
};
export default Textarea;



// WEBPACK FOOTER //
// ./src/components/FormComponents/Textarea.js